import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { Container } from "./shared";
import { PhoneMockup } from "./PhoneMockup";

const POINTS = ["No credit card to start", "Set up in 5 minutes", "Works on any phone"];

export const Hero = () => (
  <section className="relative overflow-hidden pb-20 pt-12 sm:pt-20" data-testid="landing-hero">
    <Container className="grid items-center gap-14 lg:grid-cols-[1.1fr_1fr]">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <p className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-600">
          <span className="h-2 w-2 rounded-full bg-[color:var(--brand)]" /> Built for contractors and home service pros
        </p>
        <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.04] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl" data-testid="hero-title">
          Know the job before you drive to it.
        </h1>
        <p className="mt-5 max-w-lg text-base text-slate-600 md:text-lg" data-testid="hero-subtitle">
          Homeowners send photos and answer a few questions. AI builds the scope and a price range, so you only visit the jobs worth your time.
        </p>
        <Link to="/register" data-testid="hero-cta-button"
          className="mt-8 inline-flex h-14 items-center gap-2 rounded-xl bg-[color:var(--brand)] px-7 text-lg font-semibold text-white shadow-[0_12px_30px_-12px_var(--brand)] transition-transform hover:-translate-y-0.5 active:scale-[0.98]">
          Start your 14-day free trial <ArrowRight className="h-5 w-5" />
        </Link>
        <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2">
          {POINTS.map((p) => <li key={p} className="flex items-center gap-1.5 text-sm text-slate-600"><Check className="h-4 w-4 text-emerald-600" />{p}</li>)}
        </ul>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 30, rotate: 2 }} animate={{ opacity: 1, y: 0, rotate: 0 }} transition={{ duration: 0.6, delay: 0.15 }}>
        <PhoneMockup />
      </motion.div>
    </Container>
  </section>
);
